import { LeadPageContext } from "@/modules/lead-page/context/lead-page.context";
import { queryClient } from "@/queryClient";
import { useContext } from "react";
import { useMutation } from "@tanstack/react-query";
import { startCallV2 } from "../../api/lead-page.v2.api";

const useLeadContactMethods = () => {
  const { lead } = useContext(LeadPageContext);

  const handleSearchTruecaller = (phoneNumber?: string) => {
    const numberToSearch =
      phoneNumber ||
      (lead?.data?.lead?.lead_telephones?.length === 1
        ? lead?.data?.lead?.lead_telephones[0].telephone
        : lead?.data?.lead?.lead_telephones?.find(
            (telephone) => telephone.primary === true
          )?.telephone);

    if (numberToSearch) {
      window.open(
        `https://truecaller.com/search/eg/${numberToSearch}`,
        "_blank"
      );
    }
  };

  const { mutate: startCallMutation, isLoading } = useMutation({
    mutationFn: ({ journeyUid, zoomCall }: { journeyUid: number | string, zoomCall?: boolean }) => 
      startCallV2(journeyUid, zoomCall),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["getComments"] });
      queryClient.invalidateQueries({ queryKey: ["lead-activity"] });
    },
  });

  const handleStartCall = async (zoomCall?: boolean): Promise<void> => {
    const journeyUid = lead?.data?.lead?.journey_uid;
    if (!journeyUid) return;

    await new Promise<void>((resolve) => {
      startCallMutation({ journeyUid, zoomCall }, { 
        onSettled: resolve 
      });
    });
  };

  return {
    handleSearchTruecaller,
    handleStartCall,
    isLoading,
  };
};

export default useLeadContactMethods;
